import * as React from 'react';
import { HeaderLogoAndTel } from "../../../../HeaderLogoAndTel";
import { HeaderWithNav } from "../../../../HeaderWithNav";
import * as main from "../../styles/main.module.scss";
import * as screen1 from "./style.module.scss";
import data from "./data.json";
import useMediaQuery from '@mui/material/useMediaQuery';
export const Screen1 = ({ onlyLogo=true, title, subtitle, bg1920, bg768, bg320 }) => {
  const isLaptop = useMediaQuery('(max-width:991px)');
  const isMobile = useMediaQuery('(max-width:480px)');
  return (
    <header
      className={screen1.screen1}
      style={{
        backgroundImage: isMobile ?
          `url("${bg320}")`
          : isLaptop ?
            `url("${bg768}")`
            :
            `url("${bg1920}")`
      }}
    >
      <div className="container">

        {
          onlyLogo ?
            <HeaderLogoAndTel
              phoneHide={true}
            />
            :
            <HeaderWithNav
              data={data}
              noContainer={true}
              buttonText={"Купить курс"}
              modal={false}
              anchor={"#cost"}
            />
        }

        <div className={screen1.screen1__container}>
          <div className={screen1.screen1__titleWrapper}>
            <h1 className={screen1.screen1__title}>
              { title }
            </h1>
            <h2 className={screen1.screen1__subtitle}>
              { subtitle }
            </h2>
          </div>
          <div className={screen1.screen1__linkWrapper}>
            <a className={`${screen1.screen1__link} ${main.mainBtn}`}href="#cost">
              Оставить заявку
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
